import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { useState } from 'react'
import { appAllGetBoliBooking } from '../../store/boliBooking'
import { useDispatch } from 'react-redux'
import { boliBookingExportColumns } from '../../config/exportColumns/boliBookingExportColumns'

function BoliBooking() {
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Boli Booking</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetBoliBooking({
										...params,
										...exportFilters,
										sanstha: sansthaId || permissionOfSanstha,
										page: 1,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={boliBookingExportColumns}
							fileName="Boli_Booking"
							sheetName="Boli Booking"
							buttonText="Export Boli"
						/>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default BoliBooking
